import { uiComponentsLocalizationStructure } from './index';
import { useInternationalContext } from '@rsc/gatsby-localization-helpers';

export const useUiComponentsInternationalContext = () => {
  return useInternationalContext(uiComponentsLocalizationStructure);
};
